import Blue from "~/core";

new Blue({
  name: "CookieNotice",
  selector: ".cookie-notice",
  setup(cookienotice) {
    const cookies = this.querySelector('.cookie-notice__modal');
    const closeBtn = cookies.querySelector('.cookie-notice__modal-close');
    // The accept & decline buttons may be omitted depending on
    // server-side configurations.
    const accept = cookies.querySelector('.cookie-notice__modal-accept');
    const decline = cookies.querySelector('.cookie-notice__modal-decline');
  
    // When integrated with the backend, this will always return null,
    // because this code will not be loaded if the visitor has already
    // responded.
    // Leaving just in case it's not handled correctly server-side.
    const getExistingResponse = () => getCookie('CMSCookieLevel');
  
    // If there is no Accept or Decline button, the banner is just being
    // used as a cookie notice, so let's record that the banner was closed
    // and keep it closed for `cookieNotificationWaitDays` days.
    const cookieNotificationClosedDateKey = "cookie-notification-closed-date";
    const cookieNotificationWaitDays = 180;
    const storeClosedIfNotificationMode = () => {
      if (accept || decline) return;
      localStorage.setItem(cookieNotificationClosedDateKey, JSON.stringify(new Date()));
    }
  
    const getNotificationWasRecentlyClosed = () => {
      var dateClosed = new Date(JSON.parse(localStorage.getItem(cookieNotificationClosedDateKey)));
      var diff = (new Date()) - dateClosed;
      var dayDiff = diff / (1000 * 60 * 60 * 24); 
      return (dayDiff < cookieNotificationWaitDays);
    }
  
    const toggle = new Toggle({
      content: cookies,
      trigger: closeBtn
    });
  
    const closePrompt = () => {
      toggle.close();
      closeBtn.removeAttribute('tabindex');
      accept?.removeAttribute('tabindex');
      decline?.removeAttribute('tabindex');
      storeClosedIfNotificationMode();
    };
    const openPrompt = () => {
      toggle.open();
      closeBtn.setAttribute('tabindex', 1);
      accept?.setAttribute('tabindex', 1);
      decline?.setAttribute('tabindex', 1);
      closeBtn.focus();
    };
  
    // FE Note: It's important that we don't set consent status
    // in a temporary location like local storage for the
    // front-end site, because team's will forget to change how
    // its stored when integrating it in a website.
    // Real life story: we have a project that is still using 
    // localStorage in production, so that the back-end code never
    // renders the correct GTM & Analytics scripts for accepted visitors.
    // The temporary front-end solution masked the problem.
    const setResponse = async (allowNonessentialCookies) => {
      await fetch('/api/cookies/consent', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(allowNonessentialCookies),
      });
  
      this.dispatchEvent(new CustomEvent("consent-response", {
        detail: { allowNonessentialCookies: allowNonessentialCookies }
      }));
      closePrompt();
    };
  
    addEvents(closeBtn, 'click enter', closePrompt);
    if(decline)
    {
      addEvents(decline, 'click enter', () => setResponse(false));
    }
    if(accept)
    {
      addEvents(accept, 'click enter', () => setResponse(true));
    }
  
  
    setTimeout(() => {
      if (getExistingResponse() != null) return;
      if (getNotificationWasRecentlyClosed()) return;
      openPrompt();
    }, 750);  
  },
});
